// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHistory-Stepper_cls1__482+p","cls2":"PaymentViewHistory-Stepper_cls2__bm2Mn PaymentViewHistory-Stepper_cls1__482+p"};